var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AppHeader'),(_vm.project && _vm.order)?_c('ProjectEdit',_vm._g(_vm._b({},'ProjectEdit',{
      project: _vm.project,
      order: _vm.order,
      company: _vm.company,
      office: _vm.office,
      clientOptions: _vm.clientOptions,
      clientStaffOptions: _vm.clientStaffOptions,
      templateOptions: _vm.templateOptions
    },false),{ ok: _vm.ok, cancel: _vm.cancel, updateIcon: _vm.updateIcon })):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }